import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f354bd4a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f354bd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f354bd4a')) {
      api.createRecord('f354bd4a', component.options)
    } else {
      api.reload('f354bd4a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f354bd4a&scoped=true&", function () {
      api.rerender('f354bd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QiTxy0Jx880e/JS/comp/Accordion.vue"
export default component.exports